import {Injectable} from '@angular/core';
import {GraphqlService} from './graphql.service';
import {interval, Subscription} from 'rxjs';
import {DatabaseService} from './database.service';
import {orderPollingQuery} from '../../graphql/queries/order';
import {OrderSyncError} from '../exceptions/exceptions';

import {SignalService} from './signal.service';
import {Order} from '../../graphql/generated';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class OrderSyncService {
  subscription!: Subscription;

  constructor(
    private graphqlService: GraphqlService,
    private database: DatabaseService,
    private signalService: SignalService,
  ) {
    this.handleOrderPolling().then();
  }

  async handleOrderPolling() {
    try {
      const accessToken = localStorage.getItem('accessToken');

      if (this.subscription && !this.subscription.closed) {
        this.subscription.unsubscribe();
      }

      if (accessToken) {
        this.startOrderPolling().then();
      }
    } catch (error) {
      throw new OrderSyncError('Error occurred while starting order polling.');
    }
  }

  stopPolling() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private async startOrderPolling() {
    await this.fetchAndSaveOrders(true);
    this.subscription = interval(5000).subscribe(() =>
      this.fetchAndSaveOrders(false),
    );
  }

  private async fetchAndSaveOrders(initial: boolean) {
    let currentTime = moment();
    if (initial) {
      currentTime = currentTime.subtract(1, 'days');
    } else {
      currentTime = currentTime.subtract(15, 'minutes');
    }
    try {
      const orders: Order[] = await this.getOrders(
        initial,
        currentTime.toJSON(),
      );
      await this.database.updateOrders(
        initial,
        orders,
        this.signalService.section(),
      );
    } catch (error) {
      console.error(error);
    }
  }

  private async getOrders(
    initial: boolean,
    lastUpdatedOn: string,
  ): Promise<Order[]> {
    const response = await this.graphqlService.runQuery(orderPollingQuery, {
      initial,
      lastUpdatedOn,
    });

    return response.order_polling;
  }
}
